// extracted by mini-css-extract-plugin
export default {"typing-dots":"typing-dots__QuZ2b","typing-dots__dot":"typing-dots__dot__drmqZ","typing-dots__indicator":"typing-dots__indicator__SpABe"};